(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["button"] && !Shopify.designMode) return;
  try {
    if (!window.__peKlaviyoFormBound) {
		window.__peKlaviyoFormBound = true;
		document.addEventListener('click', (event) => {
			const trigger = event.target.closest('[data-klaviyo-form-id]');
			if (!trigger) return;
			const formId = trigger.getAttribute('data-klaviyo-form-id');
			if (!formId) return;
			event.preventDefault();
			window._klOnsite = window._klOnsite || [];
			window._klOnsite.push(['openForm', formId]);
		});
	}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["carousel-tabs"] && !Shopify.designMode) return;
  try {
    class CarouselTabs extends HTMLElement {
		connectedCallback() {
			requestAnimationFrame(() => this.setup());
		}

		disconnectedCallback() {
			this.slideshow?.removeEventListener('slideshow:change', this.handleChange);
		}

		setup() {
			const section = this.closest('.section-carousel');
			if (!section) return;

			this.slideshow = section.querySelector('slideshow-component');
			if (!this.slideshow) return;

			const allSlides = this.slideshow.querySelectorAll('[data-carousel-card]');
			if (!allSlides.length) return;

			const nav = document.createElement('nav');
			nav.className = 'carousel-tabs__nav';
			nav.setAttribute('role', 'tablist');
			nav.setAttribute('aria-label', 'Carousel navigation');

			let hasAnyTab = false;

			allSlides.forEach((slide, index) => {
				const label = slide.dataset.anchorLabel;
				if (!label) return;

				hasAnyTab = true;
				const btn = document.createElement('button');
				btn.className = 'carousel-tabs__tab';
				btn.setAttribute('role', 'tab');
				btn.setAttribute('aria-selected', String(index === (this.slideshow.current ?? 0)));
				btn.dataset.slideIndex = index;
				btn.textContent = label;
				btn.addEventListener('click', () => this.slideshow.select(index));
				nav.appendChild(btn);
			});

			if (hasAnyTab) {
				this.appendChild(nav);
				this.slideshow.addEventListener('slideshow:change', this.handleChange);
			}
		}

		handleChange = (e) => {
			const index = e.detail.index;
			this.querySelectorAll('.carousel-tabs__tab').forEach((tab) => {
				tab.setAttribute('aria-selected', String(Number(tab.dataset.slideIndex) === index));
			});
		};
	}

	customElements.define('carousel-tabs', CarouselTabs);
  } catch(e) { console.error(e); }
})();

})();
